import { Component, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';

import { FormBuilder, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { NotificationService } from 'src/app/Service/notification.service';

import { OtherService } from 'src/app/Service/other.service';

import axios from 'src/app/Service/axios';

import { Meta } from '@angular/platform-browser';

import * as moment from 'moment-jalaali';

import { PersianNumberService } from 'ngx-persian';

declare let $: any;

@Component({

  selector: 'taxi-manage',

  templateUrl: './taxi-manage.component.html',

  styleUrls: ['./taxi-manage.component.css']

})

export class TaxiManageComponent implements OnInit {

  last_Input: string = '';

  col_strSource: string = 'شهر مبداء';

  col_strDestination: string = 'شهر مقصد';

  lst_Requests: any = [];

  lst_Search: any = [];

  lst_TaxiLon_Driver: any = [];

  lst_Search_2: any = [];

  lst_City: any = [];

  lst_GroupCar: any = [];

  lst_Suggestion: any = [];

  lst_Search_3: any = [];

  list_MobileType: any[] = [];

  list_MobileGroup: any[] = [];

  list_Reason: any[] = [];

  list_ReliefType: any[] = [];

  Selected_City: number | string = -1;

  bEditMode: boolean | 'showMode' | 'searchMode' = false;

  showFilter: boolean = false;

  showCustom_Map: boolean = false;

  showCustom_Map_3: boolean = false;

  showCustom_Map_2: boolean = false;

  bEmdadran: boolean = false;

  isInput_Disabled: boolean = false;

  currentTime: any = moment().format('jYYYY/jMM/jDD');

  webAppName = (<any>window).webAppName;

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    tiTripStatus: new FormControl('')

  })

  mdl_Assign: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iTaxiLon_Trip: new FormControl(''),

    iEmdadRo: new FormControl(''),

    strUnitID: new FormControl(''),

    lststrUnitID: new FormControl(''),

    bAll: new FormControl(false),

  })

  mdl_Request: FormGroup = this.FormBuilder.group({
    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),
    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),
    iTaxiLon_Trip: new FormControl(''),
    strName: new FormControl('', Validators.required), //  نام مسافر
    strFamily: new FormControl('', Validators.required), //  فامیل مسافر 
    strMobile: new FormControl('', Validators.required), //  موبایل مسافر
    tiSex: new FormControl(1, Validators.required), //  جنسیت 
    strID: new FormControl(''), //  کد ملی
    bForAnother: new FormControl(false), //  برای دیگری
    strPassengersName: new FormControl(''), //  نام مسافر دیگر
    strDate: new FormControl('', Validators.required), //  تاریخ سفر
    strTime: new FormControl('', Validators.required), //  ساعت سفر
    strSCity: new FormControl('', Validators.required), //  شهر مبدا
    fSLon: new FormControl('', Validators.required),
    fSLat: new FormControl('', Validators.required),
    strSAddress: new FormControl('', Validators.required),
    strDCity: new FormControl('', Validators.required), //  شهر مقصد
    fDLon: new FormControl('0'),
    fDLat: new FormControl('0'),
    strDAddress: new FormControl(''),
    bCameBack: new FormControl(false), //  دارای برگشت 
    bHasStop: new FormControl(false), //  داری توقف
    fEstimateStop: new FormControl(''), //  مدت توقف مثلا 3.5 ساعت 
    tiPassenger: new FormControl(1), //  تعداد مسافر
    bCargo: new FormControl(false), //  بار دارد
    strCargoDetail: new FormControl(''), //  توضیحات بار
    bPet: new FormControl(false), //  حیوان خانگی 
    bSmoking: new FormControl(false), //  سیگار مجاز
    bNeedHelp: new FormControl(false), //  نیاز به کمک 
    bInvoiceRequired: new FormControl(false), //  نیاز به فاکتور
    strCompany: new FormControl(''), //  اسم شرکت برای فاکتور
    bForeigner: new FormControl(false), //  مسافر غیر ایرانی
    bHiddenFare: new FormControl(false),
    strPassportNumber: new FormControl(''), //  شماره پاسپورت مسافر غیر ایرانی 
    strComment: new FormControl(''), //  توضیحات
    tiMobileGroup: new FormControl('', Validators.required), //  گروه خودرویی
    iEstimateRent: new FormControl(0, Validators.required), //  کرایه
    strUnitID: new FormControl(''), // شناسه خودرو
    strDriver_FullName: new FormControl(''), // نام راننده
    strDriver_Mobile: new FormControl(''), // موبایل راننده
    fEstimateKm: new FormControl(''), //  مسافت
    tiCommissionPercentage: new FormControl(''), //  درصد کمیسیون
    iAdvancePayment: new FormControl(''), //  مقدار پیش پرداخت
    _fKm: new FormControl(''), //  مسافت
    _strTime: new FormControl(''), //  مدت زمان سفر
    _index: new FormControl('-1')

  })

  mdl_Map: FormGroup = this.FormBuilder.group({

    strAddress: new FormControl(''),

    fLon: new FormControl(''),

    fLat: new FormControl(''),

    strSource: new FormControl(''),

  })

  mdl_TripSAD: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iEmdadRo: new FormControl(''), //  نام مسافر

    strName: new FormControl(''), //  نام مسافر

    strFamily: new FormControl('', Validators.required), //  فامیل مسافر 

    strMobile: new FormControl('', Validators.required), //  موبایل مسافر

    tiMobileType: new FormControl('-1', Validators.required), // نوع خودرو 

    tiReason4Request: new FormControl('-1', Validators.required), // علت درخواست 

    tiReliefRequestType: new FormControl('-1', Validators.required), // نوع درخواست امداد 

    tiCommissionPercentage: new FormControl('0'),

    strReasonStopping: new FormControl(''), // دلیل توقف   

    tiMobileGroup: new FormControl('', Validators.required), // نوع جرثقیل 

    strSCity: new FormControl('', Validators.required), // شهر مبدا

    strSAddress: new FormControl('', Validators.required), // آدرس مبداء

    fSLat: new FormControl(0, Validators.required), // موقعیت مبدا

    fSLon: new FormControl(0, Validators.required), // موقعیت مبدا

    strDCity: new FormControl(''), // شهر مقصد

    strDAddress: new FormControl(''), // آدرس مقصد

    fDLat: new FormControl(0), // موقعیت مقصد

    fDLon: new FormControl(0), // موقعیت مقصد

    strDate: new FormControl(this.persianNumber.toEnglish(new Date().toLocaleString('fa-ir')), Validators.required), // تاریخ

    strTime: new FormControl('', Validators.required), // ساعت

    bTraffic: new FormControl(false), // چک باکس طرح ترافیک

    bEvenOdd: new FormControl(false), // چک باکس طرح آلودگی 

    bBadWeather: new FormControl(false), // چک باکس شرایط آب وهوایی ویژه 

    bMountainous: new FormControl(false), // چک باکس منطقه کوهستانی 

    strComment: new FormControl(''), // توضیحات

    strVehicleNo: new FormControl(''), // پلاک

    strVehicleNo_1: new FormControl(''),

    strVehicleNo_2: new FormControl(''),

    strVehicleNo_3: new FormControl(''),

    strVehicleNo_4: new FormControl(''),

    iFixCost: new FormControl(0, Validators.required), //  کرایه اعلام شده

    iPartnerRent: new FormControl(0), //  کرایه اعلام شده

    iPartnerReceived: new FormControl(0), //  کرایه دریافت شده

    iBaseRent: new FormControl(0),

    fEstimateKm: new FormControl(''), //  مسافت

    _fKm: new FormControl(''), //  مسافت

    _strTime: new FormControl(''), //  مدت زمان سفر

    _index: new FormControl(''), // 

  });

  mdl_AssignCar: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    bAll: new FormControl(false), //  نام مسافر

  })

  @Input() isOpenModal: boolean = false;

  @Input() isCity: boolean = false;

  @Output() onClose = new EventEmitter<boolean>()

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private metaService: Meta,

    private persianNumber: PersianNumberService,


  ) { }

  ngOnInit(): void {

    this.route.parent?.url.subscribe(urlSegments => {

      if (urlSegments[0]?.path == 'emdadran') {

        this.bEmdadran = true;

        this.getMobileGroup();

      }

    });

    this.route.url.subscribe((segment: any) => {

      if (segment[0].path == 'manage-requests-city') {

        this.col_strSource = 'آدرس مبداء';

        this.col_strDestination = 'آدرس مقصد';

        this.isCity = true;

        this.getCity_Base();

      }

    })

    if (this.isOpenModal) {

      if (this.isCity) {

        this.getCity_Base();

      }

      this.city_TaxiLon();

    }

    else {

      this.city_TaxiLon();

      this.tabSwitch(1);

      setTimeout(() => {

        $('.clockpicker').clockpicker({

          donetext: 'top',

          align: 'top',

          autoclose: true,

        });

      }, 100);

      this._otherService.setTitle(this.bEmdadran ? ` ${this.webAppName} | مدیریت درخواست ها ` : `${this.webAppName} | مدیریت تاکسی ${this.isCity ? '' : 'بین'} شهری`);

    }

    $('.clockpicker').clockpicker({

      donetext: 'top',

      align: 'top',

      autoclose: true,

    });

  }

  ngOnDestroy() {

    this._otherService.setTitle(this.webAppName)

  }

  city_TaxiLon = async () => {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`TaxiLon_City_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data);

    this._otherService.nonespinner();

    if (res.bError || res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_City = res;


    // ------------------------------------------------------------- >

    this._otherService.Showspinner();

    const resp = await axios.post(`GetMobileGroup`, {});

    resp.data = JSON.parse(resp.data);

    this._otherService.nonespinner();

    if (resp.data.bError || resp.data.iResult == 0) return this._tooltip.showError(resp.data.strError);

    this.lst_GroupCar = resp.data;

    // ------------------------------------------------------------- >

    if (this.isOpenModal) {

      this.newRequest();

    }

  }

  filter_Result(strValue: string) {

    this.lst_Requests = this.lst_Search.filter((el: any) => {

      return el?.strFullName?.includes(strValue) ||

        el?.strTaxiLon_TripStatus_strComment?.toString().includes(strValue) ||

        el?.strDriver_FullName?.toString().includes(strValue) ||

        el?.strMobileGroup_strComment?.toString().includes(strValue) ||

        el?.strGPSType_strComment?.toString().includes(strValue) ||

        el?.strMobileType_strComment?.toString().includes(strValue) ||

        el?.strDCityName?.toString().includes(strValue) ||

        el?.strSAddress?.toString().includes(strValue) ||

        el?.iTaxiLon_Trip?.toString().includes(strValue) ||

        el?.strMobile?.toString().includes(strValue)

    });

    if (strValue.trim() == '') {

      this.lst_Requests = this.lst_Search;

    }

  }

  filter_Result_2(strValue: string) {

    this.lst_TaxiLon_Driver = this.lst_Search_2.filter((el: any) => {

      return el?.strCityName?.includes(strValue) ||

        el?.strMobileGroup_strComment?.toString().includes(strValue) ||

        el?.strGPSType_strComment?.toString().includes(strValue) ||

        el?.strMobileType_strComment?.toString().includes(strValue) ||

        el?.strFullName?.toString().includes(strValue) ||

        el?.strMobile?.toString().includes(strValue)

    });

    if (strValue.trim() == '') {

      this.lst_TaxiLon_Driver = this.lst_Search_2;

    }

  }

  filter_Result_3(strValue: string) {

    this.lst_Suggestion = this.lst_Search_3.filter((el: any) => {

      return el?.strFullName.includes(strValue) ||

        el?.srtrResponseType.toString().includes(strValue) ||

        el?.strMobile.toString().includes(strValue)

    });

    if (strValue.trim() == '') {

      this.lst_Suggestion = this.lst_Search_3;

    }

  }

  tabSwitch = async (tiType: number) => {

    this.lst_Requests = [];

    this.lst_Search = [];

    this.mdl_Search.patchValue({

      tiTripStatus: tiType

    })

    this._otherService.Showspinner();

    const URL_METHOD = this.bEmdadran ? 'EmdadRo_ORG_List' : 'TaxiLon_Trip_ORG_List'

    let res = JSON.parse((await axios.post(URL_METHOD, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data);

    this._otherService.nonespinner();

    if (res.bError || res.iResult == 0 || res.iResult == -1) return this._tooltip.showError(res.strError);

    this.lst_Requests = res;

    this.lst_Search = res;

  }

  open_AssignModal = async (iTaxiLon_Trip: number) => {

    this.mdl_Assign.patchValue({

      iTaxiLon_Trip: iTaxiLon_Trip,

      lststrUnitID: ''

    })

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`TaxiLon_Driver_List`, this._otherService.stringNumberToNumber(this.mdl_Assign.value))).data);

    this._otherService.nonespinner();

    this.lst_TaxiLon_Driver = res;

    this.lst_Search_2 = res;

    $("#assignModal").modal("show");


  }

  open_AssignModal_2 = async (iTaxiLon_Trip: number, isReserve: boolean = false) => {

    this.mdl_Assign.patchValue({

      iTaxiLon_Trip: this.bEmdadran ? null : iTaxiLon_Trip,

      iEmdadRo: !this.bEmdadran ? null : iTaxiLon_Trip,

      lststrUnitID: '',

    })

    this._otherService.Showspinner();

    const URL_ENDPOINT = this.bEmdadran && !isReserve ? 'EmdadRo_Driver_ListBaseStatus' : this.bEmdadran && isReserve ? 'EmdadRo_OtherDrivers_List' : isReserve ? 'TaxiLon_Trip_OtherDrivers_List' : `TaxiLon_Driver_ListBaseStatus`;

    let res = JSON.parse((await axios.post(URL_ENDPOINT, this._otherService.stringNumberToNumber(this.mdl_Assign.value))).data);

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError)

    this.lst_TaxiLon_Driver = res;

    this.lst_Search_2 = res;

    $("#assignModal_2").modal("show");


  }

  toggleCarData = async (bAll: boolean) => {

    let model = this.mdl_Assign.value;

    model.bAll = bAll;

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post('TaxiLon_Driver_ListBaseStatus', this._otherService.stringNumberToNumber(model))).data);

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError)

    this.lst_TaxiLon_Driver = res;

    this.lst_Search_2 = res;

  }

  assignCar = async () => {

    if (!this.mdl_Assign.get('lststrUnitID')?.value.length) return this._tooltip.showError('لیست انتخابی شما خالی می باشد');

    $.confirm({

      title: `از اختصاص سرویس به <strong>${this.mdl_Assign.get('lststrUnitID')?.value.length} راننده</strong> اطمینان دارید ؟`,

      content: '',

      type: 'blue',

      buttons: {

        ok: {

          text: 'تایید',

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            this._otherService.Showspinner();

            const URL_ENDPOINT = this.bEmdadran ? 'EmdadRo_Driver_AsignTrip' : 'TaxiLon_Driver_AsignTrip';

            let res = JSON.parse((await axios.post(URL_ENDPOINT, this._otherService.stringNumberToNumber(this.mdl_Assign.value))).data);

            this._otherService.nonespinner();

            if (res.iResult == 0) return this._tooltip.showError(res.strError)

            $("#assignModal").modal("hide");

            this._tooltip.showSuccess('عملیات با موفقیت انجام شد.')

            this.tabSwitch(4);

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  assignCar_2 = async () => {

    if (!this.mdl_Assign.get('lststrUnitID')?.value.length) return this._tooltip.showError('لیست انتخابی شما خالی می باشد');

    $.confirm({

      title: `از اختصاص سرویس به <strong>${this.mdl_Assign.get('lststrUnitID')?.value.length} راننده</strong> اطمینان دارید ؟`,

      content: '',

      type: 'blue',

      buttons: {

        ok: {

          text: 'تایید',

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            this._otherService.Showspinner();

            const URL_ENDPOINT = this.bEmdadran ? 'EmdadRo_AsignTripBaseStatus' : 'TaxiLon_Driver_AsignTripBaseStatus';

            let res = JSON.parse((await axios.post(URL_ENDPOINT, this._otherService.stringNumberToNumber(this.mdl_Assign.value))).data);

            this._otherService.nonespinner();

            if (res.iResult == 0) return this._tooltip.showError(res.strError)

            $("#assignModal_2").modal("hide");

            $("#assignModal_3").modal("hide");

            this._tooltip.showSuccess('عملیات با موفقیت انجام شد.')

            this.tabSwitch(4);

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  select_Driver(check: boolean, item: any) {

    const lstUnitID = this.mdl_Assign.get('lststrUnitID')?.value || [];

    if (check) {

      lstUnitID.push(item.strUnitID);

      this.mdl_Assign.patchValue({

        lststrUnitID: lstUnitID

      });

    }

    else {

      const index = lstUnitID.indexOf(item.strUnitID);

      if (index > -1) lstUnitID.splice(index, 1);

      this.mdl_Assign.patchValue({

        lststrUnitID: lstUnitID

      });

    }

  }

  selectAll_Driver() {

    const lstUnitID = this.mdl_Assign.get('lststrUnitID')?.value || [];

    if (this.lst_TaxiLon_Driver.length == lstUnitID.length) {

      this.mdl_Assign.patchValue({

        lststrUnitID: []

      });

    }

    else {

      const lstUnitID: string[] = [];

      this.lst_TaxiLon_Driver.forEach((el: any) => {

        lstUnitID.push(el.strUnitID);

      })

      this.mdl_Assign.patchValue({

        lststrUnitID: lstUnitID

      });

    }

  }

  isSelected(strUnitID: string): boolean {

    const lstUnitID = this.mdl_Assign.get('lststrUnitID')?.value || [];

    return lstUnitID.includes(strUnitID)

  }

  newRequest(item: any = {}, index: number = -1, mode?: 'showMode') {

    this.isInput_Disabled = false;

    if (this.bEmdadran) return this.newEmdadran(item, index, mode);

    if (item?.iTaxiLon_Trip) {

      Object.keys(item).forEach((key) => {

        this.mdl_Request.get(key)?.setValue(item[key]);

      })

      this.mdl_Request.get('_index')?.setValue(index);

      this.mdl_Request.get('_fKm')?.setValue('');

      this.mdl_Request.get('_strTime')?.setValue('');

      this.bEditMode = mode ? 'showMode' : true;

      // Rerender custom-filter

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

      $("#newReq_Modal").modal("show");

    }

    else {

      this.mdl_Request.patchValue({

        iTaxiLon_Trip: '',

        strName: '', //  نام مسافر

        strFamily: '', //  فامیل مسافر 

        strMobile: '', //  موبایل مسافر

        tiSex: 1, //  جنسیت 

        strID: '', //  کد ملی

        bForAnother: false, //  برای دیگری

        strPassengersName: '', //  نام مسافر دیگر

        strDate: moment().format('jYYYY/jMM/jDD'), //  تاریخ سفر

        strTime: this.isCity ? moment().format('HH:mm') : '', //  ساعت سفر

        strSCity: this.isCity ? this.getCityName() : '', //  شهر مبدا

        fSLon: '',

        fSLat: '',

        strSAddress: '',

        strDCity: this.isCity ? this.getCityName() : '', //  شهر مقصد

        fDLon: '',

        fDLat: '',

        strDAddress: '',

        bCameBack: false, //  دارای برگشت 

        bHasStop: false, //  داری توقف

        fEstimateStop: '', //  مدت توقف مثلا 3.5 ساعت 

        tiPassenger: 1, //  تعداد مسافر

        bCargo: false, //  بار دارد

        strCargoDetail: '', //  توضیحات بار

        bPet: false, //  حیوان خانگی 

        bSmoking: false, //  سیگار مجاز

        bNeedHelp: false, //  نیاز به کمک 

        bInvoiceRequired: false, //  نیاز به فاکتور

        strCompany: '', //  اسم شرکت برای فاکتور

        bForeigner: false, //  مسافر غیر ایرانی

        bHiddenFare: false,

        strPassportNumber: '', //  شماره پاسپورت مسافر غیر ایرانی 

        strComment: '', //  توضیحات

        tiMobileGroup: '', //  گروه خودرویی

        iEstimateRent: 0, //  کرایه

        strUnitID: '', // شناسه خودرو

        strDriver_FullName: '', // نام راننده

        strDriver_Mobile: '', // موبایل راننده

        fEstimateKm: '', //  مسافت

        _fKm: '', //  مسافت

        _strTime: '', //  مدت زمان سفر


      })

      this.bEditMode = false;

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

      $("#newReq_Modal").modal("show");

    }

  }

  newEmdadran(item: any = {}, index: number = -1, mode?: 'showMode') {

    if (item?.iEmdadRo) {

      Object.keys(item).forEach((key) => {

        this.mdl_TripSAD.get(key)?.setValue(typeof (item[key]) == 'boolean' ? item[key] : item[key].toString());

      })

      this.mdl_TripSAD.patchValue({

        strVehicleNo_1: item.strVehicleNo.split(' ')[0],

        strVehicleNo_2: item.strVehicleNo.split(' ')[1],

        strVehicleNo_3: item.strVehicleNo.split(' ')[2],

        strVehicleNo_4: item.strVehicleNo.split(' ')[4],

      })

      this.mdl_TripSAD.get('_index')?.setValue(index);

      this.bEditMode = mode ? 'showMode' : true;

      // Rerender custom-filter

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

      $("#newEmdad_Modal").modal("show");

    }

    else {

      this.mdl_TripSAD.patchValue({

        strName: '', //  نام مسافر

        strFamily: '', //  فامیل مسافر 

        strMobile: '', //  موبایل مسافر

        tiMobileType: -1, // نوع خودرو 

        tiReason4Request: -1, // علت درخواست 

        tiReliefRequestType: -1, // نوع درخواست امداد 

        strReasonStopping: '', // دلیل توقف   

        tiMobileGroup: '', // نوع جرثقیل 

        strSCity: '', // شهر مبدا

        strSAddress: '', // آدرس مبداء

        fSLat: 0, // موقعیت مبدا

        fSLon: 0, // موقعیت مبدا

        strDCity: '', // شهر مقصد

        strDAddress: '', // آدرس مقصد

        fDLat: 0, // موقعیت مقصد

        fDLon: 0, // موقعیت مقصد

        strDate: moment().format("jYYYY/jMM/jDD"), // تاریخ

        strTime: moment().format("HH:mm"), // ساعت

        bTraffic: false, // چک باکس طرح ترافیک

        bEvenOdd: false, // چک باکس طرح آلودگی 

        bBadWeather: false, // چک باکس شرایط آب وهوایی ویژه 

        bMountainous: false, // چک باکس منطقه کوهستانی 

        strComment: '', // توضیحات

        strVehicleNo: '', // پلاک

        strVehicleNo_1: '',

        strVehicleNo_2: '',

        strVehicleNo_3: '',

        strVehicleNo_4: '',

        iFixCost: 0, //  کرایه اعلام شده

        iPartnerReceived: 0, //  کرایه دریافت شده

        fEstimateKm: '', //  مسافت

        _fKm: '', //  مسافت

        _strTime: '', //  مدت زمان سفر

        tiCommissionPercentage: 30,

        iBaseRent: 0

      });

      this.bEditMode = false;

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

      $("#newEmdad_Modal").modal("show");

    }

  }

  getCityName() {

    return this.Selected_City;

    // return this.lst_City.filter((el: any) => el.strCityName === 'تهران').map((el: any) => el.strCity)[0];

  }

  getCity_Base = async () => {

    if (this.Selected_City == -1) {

      let model = this._otherService.stringNumberToNumber(this.mdl_Request.value);

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(`TaxiLon_Trip_ORG_UserCity`, model)).data);

      this._otherService.nonespinner();

      return this.Selected_City = res.trim();

    }

  }

  setValue_Filter(event: any, strKey: string) {

    if (this.isCity) return // اگر سفر شهری بود شهر را تغییر نده

    if (event?.strCityName) {

      if (strKey == 'strSCity') {

        this.mdl_Request.patchValue({

          strSCity: event.strCity,

          fSLon: event.fLon,

          fSLat: event.fLat,

        })

        this.mdl_TripSAD.patchValue({

          strSCity: event.strCity,

          fSLon: event.fLon,

          fSLat: event.fLat,

        })

      }

      else {

        this.mdl_Request.patchValue({

          strDCity: event.strCity,

          fDLon: event.fLon,

          fDLat: event.fLat,

        })

        this.mdl_TripSAD.patchValue({

          strDCity: event.strCity,

          fDLon: event.fLon,

          fDLat: event.fLat,

        })

      }

    }

    else {

      if (strKey == 'strSCity') {

        this.mdl_Request.patchValue({

          strSCity: '',

          fSLon: '',

          fSLat: '',

        })

        this.mdl_TripSAD.patchValue({

          strSCity: '',

          fSLon: '',

          fSLat: '',

        })

      }

      else {

        this.mdl_Request.patchValue({

          strDCity: '',

          fDLon: '',

          fDLat: '',

        })

        this.mdl_TripSAD.patchValue({

          strDCity: '',

          fDLon: '',

          fDLat: '',

        })

      }

    }

  }

  returnStrValue(strKey: string, strKeyValue: number | string, lst_: [] | any, strComment: string): string {

    return this._otherService.initialFilterValue(strKey, strKeyValue, lst_, strComment);

  }

  show_Map(mdl_Type: 'strSAddress' | 'strDAddress') {

    if (mdl_Type == 'strSAddress') {

      let mdl_Request = this.bEmdadran ? this.mdl_TripSAD : this.mdl_Request;

      let cityName = this.returnStrValue('strCity', mdl_Request.get('strSCity')?.value, this.lst_City, 'strCityName');

      let address = !mdl_Request.get('strSAddress')?.value.startsWith(cityName) ? cityName + '، ' + mdl_Request.get('strSAddress')?.value : mdl_Request.get('strSAddress')?.value;

      this.mdl_Map.patchValue({

        strAddress: address == cityName + '، ' ? '' : address,

        fLon: mdl_Request.get('fSLon')?.value == '' ? this.get_latLong(mdl_Request.get('strSCity')?.value, 'fLon') : mdl_Request.get('fSLon')?.value,

        fLat: mdl_Request.get('fSLat')?.value == '' ? this.get_latLong(mdl_Request.get('strSCity')?.value, 'fLat') : mdl_Request.get('fSLat')?.value,

        strSource: 'strSAddress'

      })

      if (this.bEmdadran) {

        this.showCustom_Map_3 = true;

      }

      else {

        this.showCustom_Map = true;

      }

    }

    else {

      // let cityName = this.returnStrValue('strCity', this.mdl_Request.get('strDCity')?.value, this.lst_City, 'strCityName');

      // let address = !this.mdl_Request.get('strDAddress')?.value.startsWith(cityName) ? cityName + '، ' + this.mdl_Request.get('strDAddress')?.value : this.mdl_Request.get('strDAddress')?.value;

      let mdl_Request = this.bEmdadran ? this.mdl_TripSAD : this.mdl_Request;

      let cityName = this.returnStrValue('strCity', mdl_Request.get('strDCity')?.value, this.lst_City, 'strCityName');

      let address = !mdl_Request.get('strDAddress')?.value.startsWith(cityName) ? cityName + '، ' + mdl_Request.get('strDAddress')?.value : mdl_Request.get('strDAddress')?.value;

      this.mdl_Map.patchValue({

        strAddress: address == cityName + '، ' ? '' : address,

        fLon: this.mdl_Request.get('fDLon')?.value == '' ? this.get_latLong(this.mdl_Request.get('strDCity')?.value, 'fLon') : this.mdl_Request.get('fDLon')?.value,

        fLat: this.mdl_Request.get('fDLat')?.value == '' ? this.get_latLong(this.mdl_Request.get('strDCity')?.value, 'fLat') : this.mdl_Request.get('fDLat')?.value,

        strSource: 'strDAddress'

      })

      if (this.bEmdadran) {

        this.showCustom_Map_3 = true;

      }

      else {

        this.showCustom_Map = true;

      }

    }

  }

  submitMap(event: any) {

    this.showCustom_Map = false;

    this.showCustom_Map_2 = false;

    this.showCustom_Map_3 = false;

    if (this.mdl_Map.get('strSource')?.value == 'strSAddress') {

      if (event.strText != '') {

        this.mdl_Request.patchValue({

          strSAddress: event.strText,

          fSLon: event.longitude,

          fSLat: event.latitude,

        })

        this.mdl_TripSAD.patchValue({

          strSAddress: event.strText,

          fSLon: event.longitude,

          fSLat: event.latitude,

        })

      }

      else {

        this.mdl_Request.patchValue({

          strSAddress: '',

          fSLon: '',

          fSLat: '',

        })

        this.mdl_TripSAD.patchValue({

          strSAddress: '',

          fSLon: '',

          fSLat: '',

        })

      }

    }

    else {

      if (event.strText != '') {

        this.mdl_Request.patchValue({

          strDAddress: event.strText,

          fDLon: event.longitude,

          fDLat: event.latitude,

        })

        this.mdl_TripSAD.patchValue({

          strDAddress: event.strText,

          fDLon: event.longitude,

          fDLat: event.latitude,

        })

      }

      else {

        this.mdl_Request.patchValue({

          strDAddress: '',

          fDLon: '',

          fDLat: '',

        })

        this.mdl_TripSAD.patchValue({

          strDAddress: '',

          fDLon: '',

          fDLat: '',

          iFixCost: 0, //  کرایه اعلام شده

          tiCommissionPercentage: 30,

        })

      }

    }

  }

  submit_Request = async () => {

    this.mdl_Request.get('strTime')?.setValue($("#strTime_").val());

    if ((!this.isCity && this.mdl_Request.invalid) || (this.isCity && this.inCity_ValidityCheck())) return this._tooltip.showError('لطفا فرم را با دقت تکمیل کنید');

    if (this.mdl_Request.get('bCargo')?.value && this.mdl_Request.get('strCargoDetail')?.value.trim() == '') {

      return this._tooltip.showError('توضیحات با را وارد کنید')

    }

    if (this.mdl_Request.get('bHasStop')?.value && (this.mdl_Request.get('fEstimateStop')?.value.trim() == '' || this.mdl_Request.get('fEstimateStop')?.value <= 0)) {

      return this._tooltip.showError('مدت توقف را مشخص کنید')

    }

    if (this.mdl_Request.get('bInvoiceRequired')?.value && this.mdl_Request.get('strCompany')?.value.trim() == '') {

      return this._tooltip.showError('جهت صدور فاکتور نام شرکت مورد نظر را وارد کنید')

    }

    if (this.mdl_Request.get('bForeigner')?.value && this.mdl_Request.get('strPassportNumber')?.value.trim() == '') {

      return this._tooltip.showError('شماره پاسپورت مسافر غیر ایرانی را وارد کنید')

    }

    if (this.mdl_Request.get('bForAnother')?.value && this.mdl_Request.get('strPassengersName')?.value.trim() == '') {

      return this._tooltip.showError('نام متقاضی را وارد کنید')

    }

    else {

      if (this.mdl_Request.get('iEstimateRent')?.value.toString().includes(',')) {

        this.mdl_Request.patchValue({

          iEstimateRent: this.mdl_Request.get('iEstimateRent')?.value.replace(/,/g, '')

        })

      }

      if (!this.bEditMode) {

        this._otherService.Showspinner();

        const ENDPOINT = this.isCity ? 'TaxiLon_Trip_City_ORG_Save' : 'TaxiLon_Trip_ORG_Save';

        let res = JSON.parse((await axios.post(ENDPOINT, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data);

        this._otherService.nonespinner();

        if (res.iResult == 0) return this._tooltip.showError(res.strError)

        this.lst_Requests.push(res[0])

        $("#newReq_Modal").modal("hide");

        this._tooltip.showSuccess('عملیات با موفقیت انجام شد');

        this.onClose.emit(true);

      }

      else {

        $.confirm({

          title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

          content: '',

          type: 'blue',

          buttons: {

            ok: {

              text: "ویرایش",

              btnClass: 'btn-primary',

              keys: ['enter'],

              action: async () => {

                this._otherService.Showspinner();

                const ENDPOINT = this.isCity ? 'TaxiLon_Trip_ORG_City_Edit' : 'TaxiLon_Trip_ORG_Edit';

                let res = JSON.parse((await axios.post(ENDPOINT, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data);

                this._otherService.nonespinner();

                if (res.iResult == 0) return this._tooltip.showError(res.strError);

                this.lst_Requests[this.mdl_Request.get('_index')?.value] = res[0];

                this._tooltip.showSuccess('عملیات با موفقیت انجام شد');

                $("#newReq_Modal").modal("hide");


              }

            },

            cancel: {

              text: "لغو",

            }

          }

        });

      }

    }

  }

  submit_Emdadran = async () => {

    this.mdl_TripSAD.get('strTime')?.setValue($("#strTime").val());

    let model = this.mdl_TripSAD.value;

    if (this.mdl_TripSAD.invalid) return this._tooltip.showError('!لطفا موارد ستاره دار را وارد کنید');

    if (this.mdl_TripSAD.get('strDate')?.value < moment().format("jYYYY/jMM/jDD")) {

      return this._tooltip.showError('تاریخ سفر نمی تواند گذشته باشد')

    }

    if (model.strTime.trim() == '') return this._tooltip.showError('ساعت را وارد کنید');

    if (model.strVehicleNo_1.trim() == '' || model.strVehicleNo_2.trim() == '' || model.strVehicleNo_3.trim() == '' || model.strVehicleNo_4.trim() == '') return this._tooltip.showError('پلاک خودرو را وارد کنید');

    if (model.strDate < this.currentTime) return this._tooltip.showError('تاریخ قبل از امروز را نمی توانید انتخاب کنید');

    if (model.strSCity == '') return this._tooltip.showError('شهر مبدا را وارد کنید');

    if (model.strSAddress == '') return this._tooltip.showError('آدرس مبدا را وارد کنید');

    if (model.fSLon == '') return this._tooltip.showError('موقعیت مبدا را وارد کنید');

    if (model.tiMobileType == '-1') return this._tooltip.showError('نوع خودرو را مشخص کنید');

    if (model.tiReliefRequestType == '-1') return this._tooltip.showError('نوع درخواست را مشخص کنید');

    if (model.tiReason4Request == '-1') return this._tooltip.showError('علت درخواست را مشخص کنید');

    if (model.tiMobileGroup == '-1') return this._tooltip.showError('نوع امدادگر را مشخص کنید');

    if (model.strVehicleNo_1) {

      model.strVehicleNo = model.strVehicleNo_1 + ' ' + model.strVehicleNo_2 + ' ' + model.strVehicleNo_3 + ' | ' + model.strVehicleNo_4;

    }

    let showConfirmationDialog = (message: string, model: any) => {

      $.confirm({

        title: `آیا از ${this.bEditMode ? 'ویرایش' : 'ثبت'} درخواست حمل اطمینان دارید ؟`,

        content: message,

        type: this.bEditMode ? 'blue' : 'green',

        buttons: {

          cancel: {

            text: "لغو",

          },

          ok: {

            text: this.bEditMode ? 'ویرایش' : "ثبت",

            btnClass: this.bEditMode ? 'btn-primary' : 'btn-success',

            keys: ['enter'],

            action: async () => {

              let model_2 = this._otherService.stringNumberToNumber(model);

              this._otherService.Showspinner();

              const URL_ENDPOINT = this.bEditMode ? 'EmdadRan_ORG_Edit' : 'EmdadRan_ORG_Save';

              let res = JSON.parse((await axios.post(URL_ENDPOINT, model_2)).data);

              this._otherService.nonespinner();

              if (this.bEditMode == true) {

                this._tooltip.showSuccess(`درخواست شما با کد ${res[0].iEmdadRo} ویرایش گردید و بزودی به آن رسیدگی بعمل می آید`);

                this.lst_Requests[this.mdl_TripSAD.get('_index')?.value] = res[0];

                this.bEditMode = false;

                $("#newEmdad_Modal").modal('hide');

              }

              else {

                this._tooltip.showSuccess(`درخواست شما با کد ${res[0].iEmdadRo} ثبت گردید و بزودی به آن رسیدگی بعمل می آید`);

                this.lst_Requests.push(res[0]);

                $("#newEmdad_Modal").modal('hide');

              }

            }

          }

        }

      });

    }

    if (model.fSLon && model.fSLat && this.isUser_OpenedMap()) {

      let model_2 = this._otherService.stringNumberToNumber(model);

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(`Rahyar24_User_TravelCostEstimate`, model_2)).data);

      this._otherService.nonespinner();

      if (res.iResult === 0) return this._tooltip.showError(res.strError);

      let message = res.iRent ? `

      <p class="fs-6"> مسافت : <strong> ${res.fKm.toLocaleString()} کیلومتر  </strong> </p>

      <p class="fs-6"> هزینه حمل(ریال) : <strong> ${res.iRent.toLocaleString()} </strong> </p>

      <p class="fs-6"> مبلغ پیش پرداخت (ریال) : <strong> ${res.iAdvancePayment.toLocaleString()} </strong> </p> ` : '';

      showConfirmationDialog(message, model);

    }

    else {

      showConfirmationDialog('', model);

    }

  }

  isUser_OpenedMap(): boolean {

    return false

    let model = this.mdl_TripSAD.value;

    if (!model.fDLon || !model.fDLat || model.fDLat == 0) {

      return false;

    }

    else if (model.fDLon && model.fDLat) {

      return !Boolean(this.lst_City.find((el) => (el.fLat == model.fDLat && el.fLon && model.fDLon)))

    }

  }

  inCity_ValidityCheck(): boolean {

    const requiredFields = [

      { key: "strMobile", isValid: (value: any) => value !== '' },

      { key: "strFamily", isValid: (value: any) => value !== '' },

      { key: "strDate", isValid: (value: any) => value !== '' },

      { key: "strTime", isValid: (value: any) => value !== '' },

      { key: "fSLon", isValid: (value: any) => value !== '' && value !== 0 },

      { key: "fSLat", isValid: (value: any) => value !== '' && value !== 0 },

      { key: "strSAddress", isValid: (value: any) => value !== '' },

      { key: "fDLon", isValid: (value: any) => value !== '' && value !== 0 },

      { key: "fDLat", isValid: (value: any) => value !== '' && value !== 0 },

      { key: "strDAddress", isValid: (value: any) => value !== '' },

      { key: "iEstimateRent", isValid: (value: any) => value !== '' && value !== 0 },

    ];

    return requiredFields.some(field => !field.isValid(this.mdl_Request.value[field.key]));

  }

  reset_calc() {

    this.mdl_Request.patchValue({

      iEstimateRent: 0,

      _fKm: '',

      _strTime: ''

    })

  }

  calc_Renting = async () => {

    let model = this._otherService.stringNumberToNumber(this.mdl_Request.value);

    if (this.isCity ? this.calcValidity() : (model.tiMobileGroup == '' || model.strSCity == '' || model.strDCity == '')) return this._tooltip.showError('لطفا فرم را با دقت تکمیل کنید');

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`TaxiLon_ORG_TravelCostEstimate`, model)).data);

    this._otherService.nonespinner();

    this.mdl_Request.patchValue({

      iEstimateRent: res.iRent.toLocaleString(),

      fEstimateKm: res.fKm,

      tiCommissionPercentage: res.tiCommissionPercentage,

      iAdvancePayment: res.iAdvancePayment,

      _fKm: res.fKm.toLocaleString() + ' کیلومتر ',

      _strTime: res.strTime

    })

  }

  calcValidity() {

    const requiredFields = [

      { key: "fSLon", isValid: (value: any) => value !== '' && value !== 0 },

      { key: "fSLat", isValid: (value: any) => value !== '' && value !== 0 },

      { key: "strSAddress", isValid: (value: any) => value !== '' },

      { key: "fDLon", isValid: (value: any) => value !== '' && value !== 0 },

      { key: "fDLat", isValid: (value: any) => value !== '' && value !== 0 },

      { key: "strDAddress", isValid: (value: any) => value !== '' },

      { key: "tiMobileGroup", isValid: (value: any) => value !== '' },

    ];

    return requiredFields.some(field => !field.isValid(this.mdl_Request.value[field.key]));

  }

  calc_Renting_2 = async () => {

    let model = this._otherService.stringNumberToNumber(this.mdl_TripSAD.value);

    if (model.tiMobileGroup == -1 || model.tiMobileGroup == '') {

      return this._tooltip.showError('نوع امدادگر را مشخص کنید');

    }

    if (model.fDLon == 0 || model.fDLon == '' || model.fSLon == 0 || model.fSLon == '') {

      return this._tooltip.showError('مختصات مبداء و مقصد را مشخصات کنید!');

    }

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Rahyar24_User_TravelCostEstimate`, model)).data);

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.mdl_TripSAD.patchValue({

      tiCommissionPercentage: res.tiCommissionPercentage,

      iBaseRent: res.iBaseRent.toLocaleString(),

      iFixCost: res.iRent.toLocaleString(),

    })


  }

  putSeprator(number: number | string, mode: 'showMode' | 'searchMode' | boolean): string | number {

    if (mode == 'showMode' || mode) {

      return number.toLocaleString();

    }

    else {
      return number
    }

  }

  cancelRequest(item: any, index: number) {

    $.confirm({

      title: `آیا از ${this.bEmdadran ? 'لغو درخواست' : 'لغو سفر'} اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "تایید",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            let model = this._otherService.stringNumberToNumber({

              ...this.mdl_Search.value,

              iTaxiLon_Trip: item.iTaxiLon_Trip || null,

              iEmdadRo: item.iEmdadRo || null

            });

            this._otherService.Showspinner();

            const URL_ENDPOINT = this.bEmdadran ? 'EmdadRo_Manager_Cancel' : 'TaxiLon_Trip_Manager_Cancel';

            let res = JSON.parse((await axios.post(URL_ENDPOINT, model)).data);

            this._otherService.nonespinner();

            if (res.bError || res.iResult == 0) return this._tooltip.showError(res.strError);

            this.lst_Requests.splice(index, 1)

            this._tooltip.showSuccess('عملیات با موفقیت انجام شد')

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  finishRequest(item: any, index: number) {

    $.confirm({

      title: `آیا از خاتمه دادن اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "تایید",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            let model = this._otherService.stringNumberToNumber({

              ...this.mdl_Search.value,

              iTaxiLon_Trip: item.iTaxiLon_Trip || null,

              iEmdadRo: item.iEmdadRo || null

            });

            this._otherService.Showspinner();

            const URL_ENDPOINT = this.bEmdadran ? 'EmdadRo_Manager_FinishTrip' : 'TaxiLon_Trip_Manager_FinishTrip';

            let res = JSON.parse((await axios.post(URL_ENDPOINT, model)).data);

            this._otherService.nonespinner();

            if (res.bError || res.iResult == 0 || res.iResult == -1) return this._tooltip.showError(res.strError);

            this.lst_Requests.splice(index, 1)

            this._tooltip.showSuccess('عملیات با موفقیت انجام شد')

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  showMap(item: any) {

    this.mdl_Map.patchValue({

      strAddress: '',

      fLon: item.fLon,

      fLat: item.fLat,

      strSource: ''

    })

    if (this.bEmdadran) {

      this.showCustom_Map_3 = true;

    }

    else {

      this.showCustom_Map = true;

    }
  }

  show_CarInfo(item: any) {

    window.open(`/carInfo/${item.strUnitID}`, '_blank')


  }

  search_ByMobile = async () => {

    let model = this._otherService.stringNumberToNumber(this.mdl_Request.value);

    if (model.strMobile == '' || model.strMobile.length != 11) return this._tooltip.showError('شماره موبایل را به درستی وارد کنید');

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`TaxiLon_User_Info4Manager`, model)).data);

    this._otherService.nonespinner();

    this.bEditMode = 'searchMode';

    setTimeout(() => {

      this.bEditMode = false;

    }, 1000);

    if (res.bError || res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    if (res.length) {

      const passenger = res[0];

      const isSameCity = this.isCity && passenger?.strCity === this.getCityName();

      this.mdl_Request.patchValue({

        strName: passenger.strName, // نام مسافر

        strFamily: passenger.strFamily, // فامیل مسافر

        tiSex: passenger.tiSex, // جنسیت

        strID: passenger.strID, // کد ملی

        strSCity: isSameCity ? passenger.strCity : !this.isCity ? passenger.strCity : this.getCityName(), // شهر مبدا

        fSLon: isSameCity && passenger.fLat > 0 ? passenger.fLon : this.isCity && !isSameCity ? this.get_latLong(this.Selected_City, 'fLon') : this.get_latLong(passenger.strCity, 'fLon'),

        fSLat: isSameCity && passenger.fLat > 0 ? passenger.fLat : this.isCity && !isSameCity ? this.get_latLong(this.Selected_City, 'fLat') : this.get_latLong(passenger.strCity, 'fLat'),

        strSAddress: isSameCity ? passenger.strAddress : !this.isCity ? passenger.strAddress : '', // آدرس مبدا

        strDAddress: '',

      });

      // Rerender custom-filter

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

    }

    else {

      this.mdl_Request.patchValue({

        strName: '', //  نام مسافر

        strFamily: '', //  فامیل مسافر 

        tiSex: '', //  جنسیت 

        strID: '', //  کد ملی

        strSCity: this.isCity ? this.getCityName() : '', //  شهر مبدا

        fSLon: '',

        fSLat: '',

        strSAddress: '',

      })

      // Rerender custom-filter

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

    }

  }

  get_latLong(strCity: number | string, target: 'fLon' | 'fLat'): number {

    return this.lst_City.filter((el: any) => { return el.strCity == strCity })[0][target];

  }

  reset_Form() {

    this.mdl_Request.patchValue({

      iTaxiLon_Trip: '',

      strName: '', //  نام مسافر

      strFamily: '', //  فامیل مسافر 

      strMobile: '', //  موبایل مسافر

      tiSex: 1, //  جنسیت 

      strID: '', //  کد ملی

      bForAnother: false, //  برای دیگری

      strPassengersName: '', //  نام مسافر دیگر

      strDate: moment().format('jYYYY/jMM/jDD'), //  تاریخ سفر

      strTime: this.isCity ? moment().format('HH:mm') : '', //  ساعت سفر

      strSCity: this.isCity ? this.mdl_Request.value.strSCity : '', //  شهر مبدا

      fSLon: '',

      fSLat: '',

      strSAddress: '',

      strDCity: this.isCity ? this.mdl_Request.value.strDCity : '', //  شهر مقصد

      fDLon: '',

      fDLat: '',

      strDAddress: '',

      bCameBack: false, //  دارای برگشت 

      bHasStop: false, //  داری توقف

      fEstimateStop: '', //  مدت توقف مثلا 3.5 ساعت 

      tiPassenger: 1, //  تعداد مسافر

      bCargo: false, //  بار دارد

      strCargoDetail: '', //  توضیحات بار

      bPet: false, //  حیوان خانگی 

      bSmoking: false, //  سیگار مجاز

      bNeedHelp: false, //  نیاز به کمک 

      bInvoiceRequired: false, //  نیاز به فاکتور

      strCompany: '', //  اسم شرکت برای فاکتور

      bForeigner: false, //  مسافر غیر ایرانی

      bHiddenFare: false, //  مسافر غیر ایرانی

      strPassportNumber: '', //  شماره پاسپورت مسافر غیر ایرانی 

      strComment: '', //  توضیحات

      tiMobileGroup: '', //  گروه خودرویی

      iEstimateRent: 0, //  کرایه

      strUnitID: '', // شناسه خودرو

      strDriver_FullName: '', // نام راننده

      strDriver_Mobile: '', // موبایل راننده

      fEstimateKm: '', //  مسافت

      tiCommissionPercentage: '', //  درصد کمیسیون

      iAdvancePayment: '', //  مقدار پیش پرداخت

      _fKm: '', //  مسافت

      _strTime: '', //  مدت زمان سفر

    })

    // اگر سفر بین شهری بود

    if (!this.isCity) {

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

    }


  }

  closeModal() {

    this.onClose.emit(true);

  }

  suggestion_Status = async (item: any) => {

    this.mdl_Assign.patchValue({

      iTaxiLon_Trip: ''

    })

    var model = {

      ...this.mdl_Search.value,

      iTaxiLon_Trip: item.iTaxiLon_Trip || null,

      iEmdadRo: item.iEmdadRo || null,

    }

    this._otherService.Showspinner();

    const URL_ENDPOINT = this.bEmdadran ? 'EmdadRo_Drivers_List' : 'TaxiLon_Trip_Drivers_List';

    let res = JSON.parse((await axios.post(URL_ENDPOINT, this._otherService.stringNumberToNumber(model))).data);

    this._otherService.nonespinner();

    if (res.bError || res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_TaxiLon_Driver = res; // for select all checkbox

    this.lst_Suggestion = res;

    this.lst_Search_3 = res;

    this.mdl_Assign.patchValue({

      iTaxiLon_Trip: item.iTaxiLon_Trip

    })

    $("#assignModal_3").modal("show");

  }

  sortColumn() {

    this.lst_Suggestion.sort((a: any, b: any) => {

      var textA = a.strTime;
      var textB = b.strTime;

      if (textA > textB)
        return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
      if (textA < textB)
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      return

    })

  }

  sortColumn_Trip() {

    this.lst_TaxiLon_Driver.sort((a: any, b: any) => {

      var textA = a.iTrip;
      var textB = b.iTrip;

      if (textA > textB)
        return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
      if (textA < textB)
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      return

    })

  }

  sortColumn_Cancel() {

    this.lst_TaxiLon_Driver.sort((a: any, b: any) => {

      var textA = a.iCancel;
      var textB = b.iCancel;

      if (textA > textB)
        return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
      if (textA < textB)
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      return

    })

  }

  sortColumn_Time() {

    this.lst_TaxiLon_Driver.sort((a: any, b: any) => {

      // Handle undefined or null values as empty strings

      const timeA = a.strTime || "";

      const timeB = b.strTime || "";

      if (timeA === "" && timeB !== "") return 1; //  a should come after b.

      if (timeB === "" && timeA !== "") return -1; //  a should come before b.

      if (timeA === "" && timeB === "") return 0; // positions should stay unchanged.

      return timeA.localeCompare(timeB);

    });
  }

  sortColumn_Date() {

    this.lst_TaxiLon_Driver.sort((a: any, b: any) => {

      if (a.strDate === "" && b.strDate !== "") return 1; //  a should come after b.

      if (b.strDate === "" && a.strDate !== "") return -1; //  a should come before b.

      if (a.strDate === "" && b.strDate === "") return 0; // positions should stay unchanged.

      return a.strDate.localeCompare(b.strDate);

    });


  }

  // 

  getMobileGroup = async () => {

    this._otherService.Showspinner();

    let res = (await axios.post(`GetMobileType`, {})).data;

    if (res.bError || res.iResult == 0) return this._tooltip.showError(res.strError);

    this.list_MobileType = res;

    // ---------------------------------------------------------------

    let res_2 = JSON.parse((await axios.post(`GetMobileGroup`)).data);

    if (res_2.bError || res_2.iResult == 0) return this._tooltip.showError(res_2.strError);

    this.list_MobileGroup = res_2;

    // ---------------------------------------------------------------

    let res_3 = JSON.parse((await axios.post(`Reason4Request`)).data);

    if (res_3.bError || res_3.iResult == 0) return this._tooltip.showError(res_3.strError);

    this.list_Reason = res_3;

    // ------------------------------------------------------------------------

    let res_4 = JSON.parse((await axios.post(`ReliefRequestType`)).data);

    this._otherService.nonespinner();

    if (res_4.bError || res_4.iResult == 0) return this._tooltip.showError(res_4.strError);

    this.list_ReliefType = res_4;


  }

  search_ByMobile_Emdadran = async () => {

    let model = this._otherService.stringNumberToNumber(this.mdl_TripSAD.value);

    if (model.strMobile == '' || model.strMobile.length != 11) return this._tooltip.showError('شماره موبایل را به درستی وارد کنید');

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`TaxiLon_User_Info4Manager`, model)).data);

    this._otherService.nonespinner();

    this.bEditMode = 'searchMode';

    setTimeout(() => {

      this.bEditMode = false;

    }, 1000);

    if (res.bError || res.iResult == 0) return this._tooltip.showError(res.strError);

    if (res.length) {

      this.mdl_TripSAD.patchValue({

        strName: res[0].strName, //  نام مسافر

        strFamily: res[0].strFamily, //  فامیل مسافر 

        strSCity: res[0].strCity, //  شهر مبدا

        fSLon: res[0].fLon > 0 ? res[0].fLon : this.get_latLong(res[0].strCity, 'fLon'),

        fSLat: res[0].fLat > 0 ? res[0].fLat : this.get_latLong(res[0].strCity, 'fLat'),

        strSAddress: res[0].strAddress,

      })

      // Rerender custom-filter

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

    }

    else {

      this.mdl_TripSAD.patchValue({

        strName: '', //  نام مسافر

        strFamily: '', //  فامیل مسافر 

        strSCity: '', //  شهر مبدا

        fSLon: '',

        fSLat: '',

        strSAddress: '',

      })

      // Rerender custom-filter

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

    }

  }

  show_Car_OnMap(item) {

    window.open('/tracker/' + item.strUnitID, '_blank')

  }

  showMap_Cluster() {


    if (!this.lst_Requests.length) return this._tooltip.showError('نتیجه ایی یافت نشد!');

    window.localStorage.removeItem('x5SBJaw');

    window.localStorage.setItem("x5SBJaw", this.gurdService.encrypt(JSON.stringify(this.lst_Requests)));

    window.open('/emdadran/search-requests/map', '_blank')

  }

  updateValue(value) {

    this.mdl_TripSAD.get('tiReliefRequestType')?.setValue(value);

    if (value >= 2) {

      this.clearField({

        tiReason4Request: 0,

        tiMobileGroup: 0,

        strDCity: '',

        strDAddress: '',

        fDLat: 0,

        fDLon: 0

      });

      this.updateValidity({

        strComment: '',


      })

      this.isInput_Disabled = true;


    }

    else {

      this.isInput_Disabled = false;

      this.updateValidity({

        tiReason4Request: -1,

        tiMobileGroup: -1

      })

      this.clearField({

        strComment: '',

        strDCity: '',

        strDAddress: '',

        fDLat: 0,

        fDLon: 0,

      });

    }

  }

  private updateValidity(fields: { [key: string]: any }) {
    Object.entries(fields).forEach(([key, value]) => {
      const control = this.mdl_TripSAD.get(key);
      control.setValidators(Validators.required);
      control.setValue(value);
      control.updateValueAndValidity();
    })

  }

  private clearField(fields: { [key: string]: any }) {
    Object.entries(fields).forEach(([key, value]) => {
      const control = this.mdl_TripSAD.get(key);
      if (control) {
        control.setValue(value);
        control.clearValidators();
        control.updateValueAndValidity();
      }
    });

  }


}
